module.exports = __webpack_public_path__ + "images/bannerEN-81e8bde863454e6d03445f6373c1c250.png";